export default __webpack_public_path__ + "static/media/icon-close.9580a8be.svg";